import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, AlertController } from '@ionic/angular';
import { BoasVindasViewModel } from './BoasVindasViewModel';
import { BaseDialog } from 'src/pages/base.dialog';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';

@Component({
  selector: 'boas-vindas-dialog',
  templateUrl: 'boas-vindas.dialog.html',
  styleUrls: ['boas-vindas.dialog.scss']
})
export class BoasVindasDialog extends BaseDialog {

  constructor(
    public router: Router, 
    public modalCtrl: ModalController,
    public alertController: AlertController){
      super(modalCtrl, router)
  }

  boasVindasViewModel: BoasVindasViewModel
  alertComponent: AlertComponent
  toggleDiasGratis = true

  ngOnInit() {
    this.iniciaVariaveis()
    this.boasVindas()
  }

  iniciaVariaveis() {
    this.boasVindasViewModel = new BoasVindasViewModel()
    this.boasVindasViewModel.setContext(this)
  }

  async boasVindas() {
    try {
      await this.boasVindasViewModel.processoBoasVindas()
    } catch (e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
    }
  }
}
